import { render } from "./AdditionalBar.vue?vue&type=template&id=9668095a&scoped=true"
import script from "./AdditionalBar.vue?vue&type=script&lang=js"
export * from "./AdditionalBar.vue?vue&type=script&lang=js"

import "./AdditionalBar.vue?vue&type=style&index=0&id=9668095a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9668095a"]])

export default __exports__